import { render, staticRenderFns } from "./PatientEligibility.vue?vue&type=template&id=56701f2b"
import script from "./PatientEligibility.vue?vue&type=script&lang=js"
export * from "./PatientEligibility.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports